/** English (default) — original site copy */
export default {
  brand: {
    linePrimaryZh: '深圳市尚音芯声科技有限公司',
    lineSecondaryEn: 'Shenzhen Shangyin Xinsheng Technology Co., Ltd.',
    singleLine: 'Shenzhen Shangyin Xinsheng Technology Co., Ltd.',
  },
  site: {
    documentTitle: 'Shenzhen Shangyin Xinsheng Technology Co., Ltd.',
  },
  nav: {
    home: 'Home Page',
    productCenter: 'Product Center',
  },
  footer: {
    copyright: '<span style="margin: 0;text-align: center;font-size: 13px;line-height: 1.6;color: #b0b0b0;letter-spacing: 0.02em;">Copyright © Shenzhen Shangyin Xinsheng Technology Co., Ltd.</span>'
  },
  lang: {
    zh: '简体中文',
    ja: '日本語',
    en: 'English',
  },
  hero: {
    slideAlt1: 'Home banner',
    slideAlt2: 'Home banner',
    slideAlt3: 'Home banner',
  },
  category: {
    sectionTitle: 'PRODUCT CATEGORY',
    power: 'PORTABLE\nPOWER BANK',
    wearables: 'SMART\nWEARABLES',
    tws: 'TWS',
    speaker: 'BLUETOOTH\nSPEAKER',
    others: 'OTHERS',
  },
  home: {
    popularTitle: 'POPULAR PRODUCT',
    popular: {
      p1: 'B18 POWER BANK',
      p2: 'S9 SMART WATCH',
      p3: 'H15 HEADPHONES',
      p4: 'BX09 HEADPHONES',
    },
    aboutTitle: 'ABOUT US',
    about1_html:
      'Shenzhen Shangyin Xinxing Technology Co., Ltd. was established on December 23, 2025. <span class="about-highlight" style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;">It is an innovative technology enterprise rooted in Shenzhen, focusing on the 3C electronics and consumer electronics fields, and building a dual-drive model of B-end supply chain empowerment and C-end cross-border operations in Japan.</span> With solid industrial service capabilities and acute market insights, we have achieved a global layout covering both domestic and overseas markets.',
    about2_html:
      '<span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;" class="about-b2-highlight">Targeting the B-end market,</span> we focus on providing in-depth services for the high-quality supply chain. We have integrated resources from over <span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;" class="about-b2-highlight">300 high-quality suppliers</span> and established a stable, efficient and quality-assured supply chain system. At the same time, <span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500;" class="about-b2-highlight">we have equipped a cutting-edge technical R&amp;D team in the 3C products industry to provide full-chain empowerment for the cooperating enterprises,</span> from product development to supply chain integration. Relying on strong channel integration capabilities, we not only stabilize domestic market services but also establish channels on major Japanese e-commerce platforms and offline supermarkets, providing comprehensive support for customers to expand markets both domestically and',
    about3_html:
      'Targeting the C-end market, <span class="about-b3-highlight">the company has deeply cultivated the online consumption market of 3C products in Japan, accurately grasping the core demands of Japanese consumers for quality and technology.</span> Currently, the store links we operate on major mainstream e-commerce platforms in Japan are performing well, and we possess mature cross-border operation and brand-building capabilities. <span class="about-b3-highlight">We continue to supply high-quality Chinese 3C products at reasonable prices to the Japanese market.</span>',
    about4_html:
      '<span>In the future, </span><span style=" display: inline;font-size: 25px;color: #3b71ca;font-weight: 500; class="about-b2-highlight">Shangyin Xinxing will continue to deepen the synergy between B and C ends,</span> based on a high-quality supply chain, with technological research and development as the engine, and with refined cross-border operations as the key point. It aims to become a new leading benchmark enterprise that connects the 3C industries in China and Japan and provides full-chain empowerment for industrial development.',
    contactAddressTitle: 'COMPANY ADDRESS',
    contactAddressText:
      '703F, HU YI WEALTH CENTER, DALONG SUBDISTRICT,<br/> LONGHUA DISTRICT, SHENZHEN CITY',
    contactEmailTitle: 'EMAIL ADDRESS',
    contactEmailText: 'SERVICE@SHANGYINXINSHENG.COM',
  },
  common: {
    details: 'Details',
    contactUs: 'CONTACT US',
  },
  productCenter: {
    titles: {
      power: 'PORTABLE POWER BANK',
      wearables: 'SMART WEARABLES',
      tws: 'TWS',
      twsHeadphones: 'TWS HEADPHONES',
      speaker: 'BLUETOOTH SPEAKER',
      others: 'OTHERS',
    },
  },
  productName: {
    power1: 'B18 POWER BANK',
    power2: 'CDB-006 POWER BANK',
    power3: 'B15 POWER BANK',
    power4: '2005B POWER BANK',
    power5: 'B10 POWER BANK',
    power6: 'CDB-006 POWER BANK',
    power7: 'B11 POWER BANK',
    power8: 'V11 POWER BANK',
    power9: 'B12 POWER BANK',
    smart1: 'S11<br>SMART WATCH',
    smart2: 'S9<br>SMART WATCH',
    smart3: 'ZL99J<br>SMART WATCH',
    smart4: 'Z145<br>SMART WATCH',
    smart5: 'ZL02CPRO<br>SMART WATCH',
    smart6: 'ZL73J<br>SMART WATCH',
    smart7: 'ZL54J<br>SMART WATCH',
    smart8: 'ZL169<br>SMART WATCH',
    smart9: 'Z136<br>SMART WATCH',
    smart10: 'Z123<br>SMART WATCH',
    tws1: 'T8<br> BLUETOOTH HEADPHONES',
    tws2: 'BX09 WIRELESS BLUETOOTH<br>HEADPHONES',
    tws3: 'H15<br> BLUETOOTH HEADPHONES',
    tws4: 'S13 BLUETOOTH <br> HEADPHONES',
    tws5: 'S58  BLUETOOTH<br> HEADPHONES',
    tws6: 'S57 BLUETOOTH <br> HEADPHONES',
    tws7: 'W09 BLUETOOTH <br> HEADPHONES',
    tws8: 'E09 BLUETOOTH <br> HEADPHONES',
    tws9: 'H10 BLUETOOTH <br> HEADPHONES',
    tws10: 'T08 BLUETOOTH <br> HEADPHONES',
    tws11: 'Y12 BONE CONDUCTION',
    tws12: 'S75 BLUETOOTH HEADPHONES',
    tws13: 'H35 BLUETOOTH HEADPHONES',
    speaker1: 'BT-2928<br>BLUETOOTH SPEAKER',
    speaker2: 'BT-2612<br>BLUETOOTH SPEAKER',
    speaker3: 'BT-2602 RGB<br>BLUETOOTH SPEAKER',
    others1: 'F11<br>NECK FAN',
    others2: 'TP107C1 GALLIUM NIT-<br>RIDE CHARGING HEAD',
    others3: 'TP65C2U1 GALLIUM NIT-<br>RIDE CHARGING HEAD',
    others4: 'OJD-88 FOUR-IN-ONE<br>WIRELESS CHARGER',
    others5: 'KR8<br>NEC FAN',
    others6: 'S70 THREE-IN-ONE<br>SHAVING KIT',
    others7: 'H13 WIRELESS FOLDABLE<br>VACUUM CLEANER',
    others8: 'YL-001<br>HUMIDIFIER',
    others9: 'P4<br>APPLE PENCIL',
    others10: 'P3<br>APPLE PENCIL',
    others11: 'E03<br>APPLE PENCIL',
    others12: 'MV53 HIGH-SPEED<br>HAIR DRYER',
    others13: 'ML-JB-01 STRAI-<br>GHTENING IRON',
    others14: 'ZY-3101 CAR<br>VACUUM CLEANER',
    others15: 'WETAG ANTI-LOST<br>DEVICE',
    others16: 'S108 SHAVING<br>RAZOR',
    others17: 'S109 THREE-IN-ONE<br>SHAVING KIT',
  },
  detail: {
    featuresTitle: 'FEATURES',
    ariaPrev: 'Previous image',
    ariaNext: 'Next image',
    thumbCarousel: 'Product thumbnails',
    p1: {
      name_html: 'B18<br/>PORTABLE CHARGER',
      features_html:
        'Three wires, dual USB-A ports, large screen digital display,<br/>built-in outdoor hanging rope',
      specs: [
        { label: 'Model', value: 'B18' },
        { label: 'Material', value: 'PC + ABS' },
        { label: 'Battery', value: '146074*1' },
        { label: 'Type-C port input / MICRO port input:', value: '5V 2A' },
        { label: 'USB built-in cable input', value: '5V 2A' },
        { label: 'USB 1-2 port output', value: '5V 2A' },
        { label: 'Lightning built-in cable output', value: '5V 2A' },
        { label: 'Type-C built-in cable output', value: '5V2A' },
      ],
    },
    p2: {
      name_html: 'S9 SMART WATCH',
      features_html: '',
      specs: [
        { label: 'Display size', value: '2.01-inch screen' },
        { label: 'Screen pixels', value: '240*296' },
        { label: 'Screen type', value: 'IPS TFT' },
        { label: 'PPI', value: '190' },
        { label: 'Capacity (current * time)', value: '1000mAh' },
        { label: 'Battery capacity (battery * voltage)', value: '3.8Wh' },
        { label: 'Usage time', value: '20-30 days' },
        { label: 'Standby time', value: '80-120 days' },
        { label: 'Body', value: 'PC+ABS' },
        { label: 'Watch strap', value: 'Silicone' },
        { label: 'CPU', value: 'Jier 7074A5' },
        { label: 'Bluetooth', value: 'Bluetooth 5.3 + EDR' },
        { label: 'Touch', value: 'Full touch full stick OGS' },
        { label: 'Android', value: 'System version 6.0 or above' },
        { label: 'Apple', value: 'System version 9.0 or above' },
      ],
    },
    p3: {
      name_html: 'H15 BLUETOOTH<br/> HEADPHONES',
      features_html:
        'Does not block the ear canal, does not shape the ear, is<br/>compatible with wearing glasses, allows ear canal ventilation,.',
      specs: [
        { label: 'ANC/ENC', value: 'N/A' },
        { label: 'Water Resistance Level', value: 'IPX4' },
        { label: 'Audio Channel System', value: 'Dual Channel' },
        { label: 'Bluetooth version', value: 'V6.0' },
        { label: 'Bluetooth effective distance', value: '> 10 meters' },
        { label: 'Frequency response', value: '20Hz - 20KHz' },
        { label: 'Charging interface', value: 'Type-C' },
        { label: 'Audio Channel System', value: 'Dual Channel' },
      ],
    },
    p4: {
      name_html: 'BX09 BLUETOOTH<br/>HEADPHONES',
      features_html:
        'Latest Bluetooth 5.3 version, low power consumption,<br/>high-performance speaker, large-capacity battery,<br/>intelligent voice wake-up, one-click reset function supported.',
      specs: [
        { label: 'Headphone size', value: '30.7*18.7*19.2mm' },
        { label: 'Charging case size', value: '57.0*46.0*23.5mm' },
        { label: 'Bluetooth', value: 'Bluetooth V5.3' },
        { label: 'Transmission distance', value: '> 10 meters' },
        { label: 'Headphone standby', value: '90 days' },
        { label: 'Charging case standby', value: 'ABS' },
        { label: 'Shell material', value: '851327/300mAh' },
        { label: 'Charging case battery capacity', value: '5V2A' },
      ],
    },
  },
}
